export default {
  method_unavailable: 'Diese Zahlungsart ist gerade nicht verfügbar. Wähle eine andere.',
  payment_option_unavailable: 'Diese Zahlungsoption ist gerade nicht verfügbar. Wähle eine andere Zahlungsart.',
  online_payment_unavailable: 'Online-Zahlung ist gerade nicht verfügbar. Versuch es gleich noch einmal.',
  retry_payment_methods: 'Erneut versuchen',
  payment_not_ready: 'Deine Zahlung wird noch vorbereitet. Versuch es gleich noch einmal.',
  wallet_total_changed:
    'Der Gesamtbetrag für diese Zahlungsart hat sich geändert. Prüf ihn und tipp noch einmal auf den Button.',
  wallet_tap_above: 'Tipp oben auf den {{method}}-Button, um zu bezahlen, oder wähle eine andere Zahlungsart.',
  wallet_pay_above: 'Nutze oben den {{method}}-Button',
  element_incomplete: 'Vervollständige deine Zahlungsdaten, um fortzufahren.',
  element_incomplete_card: 'Überprüfe deine Kartendaten und versuch es noch einmal.',
  element_incomplete_bank: 'Wähle deine Bank, um fortzufahren.',
  element_incomplete_sepa_debit: 'Überprüfe deine IBAN und die Angaben zum Kontoinhaber, um fortzufahren.',
};
